import { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    //get theme name from redux
    const themeName = useSelector((state) => state.theme.currentTheme);
    useEffect(() => {
        const body = document.body;
        //remove any previous theme class
        body.classList.forEach((cls) => {
            if (cls.startsWith("theme") || cls === "Default") {
                body.classList.remove(cls);
            }
        });
        //if no theme is available, fallback to "Default"
        const activeTheme = themeName && themeName.trim() !== "" ? themeName : "Default";
        //add the correct theme class
        body.classList.add(activeTheme);
    }, [themeName]);

    return children;
};

